import {Component} from '@angular/core';
import {ViewController} from 'ionic-angular';
import {SBSuiteManager} from '../../modules/sbsuite/providers/sbsuite.manager';


/**
 * Modal para la selección de una OF interna
 *
 * @export
 * @class InternalsModal
 */
@Component({
    selector: 'page-internals-modal',
    templateUrl: 'internals.modal.html'
  })
  export class InternalsModal {

    /**
     * Crea una instancia de InternalsModal.
     * 
     * @param {ViewController} _viewCtrl Controlador de vistas.
     * @param {SBSuiteManager} _sbSuiteManager Gestor de sbSuite.
     * @memberof InternalsModal
     */
    constructor(
        private _viewCtrl: ViewController,
        public _sbSuiteManager: SBSuiteManager
    ) {}
  

    /**
     * Inicia la OF interna seleccionada y cierra el modal.
     *
     * @param {*} internal
     * @memberof InternalsModal
     */
    selectInternal(internal: any) {
        internal.operator = this._sbSuiteManager.sbSuite.currentOperator;
        this._sbSuiteManager.sbSuite.current = internal;
        this._sbSuiteManager.cambiarOf(internal.operation.code, internal.operator);
        this._viewCtrl.dismiss();
    }

    /**
     * Cierra el modal sin selección
     *
     * @memberof InternalsModal
     */
    dismiss(){
      this._viewCtrl.dismiss();
    }
  }


// WEBPACK FOOTER //
// ./src/pages/auto-clocking/internals.modal.ts